import axios from "axios";
import { Student, StudentStatus } from "../students/api";

export const studentStatusApi = {
  getAll: async (params?: {
    page?: number;
    limit?: number;
    status?: StudentStatus | "";
    sessionId?: string;
    classId?: string;
    sectionId?: string;
    search?: string;
  }) => {
    const response = await axios.get("/scholar-register/student-status", {
      params,
    });
    return response.data as {
      data: Student[];
      meta: { total: number; page: number; limit: number; totalPages: number };
    };
  },

  getSummary: async (params?: {
    sessionId?: string;
    classId?: string;
    sectionId?: string;
    search?: string;
  }) => {
    const response = await axios.get(
      "/scholar-register/student-status/summary",
      { params },
    );
    return response.data as Record<string, number>;
  },

  changeStatusBulk: async (
    studentIds: string[],
    payload: {
      status: StudentStatus;
      reason?: string;
      effectiveDate?: string;
    },
  ) => {
    const response = await axios.patch(
      "/scholar-register/student-status/bulk",
      {
        studentIds,
        ...payload,
      },
    );
    return response.data;
  },
};
